// extracted by mini-css-extract-plugin
export default {"SelectImageVersion":"SelectImageVersion_SelectImageVersion__nlxls"};